import { z } from 'zod';

// 기본 이벤트 스키마
export const BaseEventSchema = z.object({
  event: z.string(),
  data: z.record(z.any()),
  userId: z.string().optional(),
  sessionId: z.string().optional(),
  timestamp: z.string().optional(),
});

// 분석 이벤트 스키마
export const AnalyticsEventSchema = BaseEventSchema.extend({
  event: z.string(),
  data: z.object({
    page: z.string().optional(),
    title: z.string().optional(),
    referrer: z.string().optional(),
    userAgent: z.string().optional(),
    button: z.string().optional(),
    action: z.string().optional(),
    category: z.string().optional(),
    value: z.number().optional(),
    element: z.string().optional(),
  }),
});

// 연락처 이벤트 스키마
export const ContactEventSchema = z.object({
  name: z.string().min(1, '이름을 입력해주세요'),
  email: z.string().email('올바른 이메일을 입력해주세요'),
  message: z.string().min(1, '메시지를 입력해주세요'),
  subject: z.string().optional(),
  phone: z.string().optional(),
  company: z.string().optional(),
  source: z.string().optional(),
});

// 배치 이벤트 스키마
export const BatchEventSchema = z.object({
  events: z.array(BaseEventSchema),
  batchId: z.string().optional(),
  source: z.string().optional(),
});

// 웹훅 설정 스키마
export const WebhookConfigSchema = z.object({
  contactWebhookUrl: z.string().url().optional(),
  analyticsWebhookUrl: z.string().url().optional(),
  batchWebhookUrl: z.string().url().optional(),
  retryAttempts: z.number().min(1).max(10).optional(),
  retryDelay: z.number().min(100).max(10000).optional(),
  timeout: z.number().min(1000).max(60000).optional(),
});

// 타입 추론
export type AnalyticsEventData = z.infer<typeof AnalyticsEventSchema>;
export type ContactEventData = z.infer<typeof ContactEventSchema>;
export type BatchEventData = z.infer<typeof BatchEventSchema>;
export type BaseEventData = z.infer<typeof BaseEventSchema>;
export type WebhookConfig = z.infer<typeof WebhookConfigSchema>; 